// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"8a6a2083","453":"64b99ade"}[chunkId] + ".chunk.js";
};